<div class="w-100" fxLayout="column" fxLayoutGap=".5em">
    <div *ngFor="let occasion of dateOccasions.controls; let i = index">
        <div fxLayout="column" [formGroup]="occasion | cast">
            <ng-container *ngIf="displayedDates === 'occasions'">
                <div
                    *ngIf="!hideOccasionDates"
                    class="date-row-wrapper"
                    fxFlex="100%"
                    fxLayout="row"
                    fxLayout.lt-md="column"
                    fxLayoutAlign="space-between center"
                    fxLayoutAlign.lt-md="center start"
                    fxLayoutGap=".5em"
                >
                    <div class="date occ_start_date" fxFlex="grow" fxLayoutAlign="start center">
                        <mat-form-field fxFlex="0 0 90%">
                            <input
                                matInput
                                formControlName="start_date"
                                [matDatepicker]="occstartDate"
                                placeholder="Start date"
                                i18n-placeholder="@@startDate"
                            />
                            <mat-datepicker-toggle matSuffix [for]="occstartDate"></mat-datepicker-toggle>
                            <mat-datepicker #occstartDate></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="date occ_end_date" fxFlex="grow" fxLayoutAlign="start center">
                        <mat-form-field fxFlex="0 0 90%" matTooltip="Course occasion date period ends" i18n-matTooltip>
                            <input
                                matInput
                                formControlName="end_date"
                                [matDatepicker]="occendDate"
                                placeholder="End date"
                                i18n-placeholder="@@endDate"
                            />
                            <mat-datepicker-toggle matSuffix [for]="occendDate"></mat-datepicker-toggle>
                            <mat-datepicker #occendDate></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <button
                        *ngIf="i == 0"
                        class="add-date-btn"
                        color="primary"
                        mat-icon-button
                        (click)="addDate()"
                        matTooltip="Add application period"
                        i18n-matTooltip
                    >
                        <mat-icon class="material-icons-outlined">add_circle</mat-icon>
                    </button>
                    <button
                        *ngIf="i != 0"
                        class="add-date-btn"
                        color="primary"
                        mat-icon-button
                        (click)="removeDate(i)"
                        matTooltip="Remove application period"
                        i18n-matTooltip
                    >
                        <mat-icon class="material-icons-outlined">do_not_disturb_on</mat-icon>
                    </button>
                </div>
            </ng-container>

            <ng-container *ngIf="displayedDates === 'enrollment'">
                <div
                    *ngIf="!hideApplicationPeriod"
                    class="date-row-wrapper application-period"
                    fxFlex="100%"
                    fxLayout="row"
                    fxLayout.lt-md="column"
                    fxLayoutAlign="space-between center"
                    fxLayoutAlign.lt-md="center start"
                    fxLayoutGap=".5em"
                >
                    <div class="app-start-date" fxFlex="grow" fxLayoutAlign="start center">
                        <mat-form-field fxFlex="0 0 90%">
                            <input
                                matInput
                                formControlName="application_start_date"
                                [matDatepicker]="applicationStartDate"
                                placeholder="Enrollment/Registration start date"
                                i18n-placeholder="@@enrollment/registrationStartDate"
                            />
                            <mat-datepicker-toggle matSuffix [for]="applicationStartDate"></mat-datepicker-toggle>
                            <mat-datepicker #applicationStartDate></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="date" fxFlex="grow" fxLayoutAlign="start center">
                        <mat-form-field fxFlex="0 0 90%">
                            <input
                                matInput
                                formControlName="application_end_date"
                                [matDatepicker]="applicationEndDate"
                                placeholder="End date"
                                i18n-placeholder="@@endDate"
                            />
                            <mat-datepicker-toggle matSuffix [for]="applicationEndDate"></mat-datepicker-toggle>
                            <mat-datepicker #applicationEndDate></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <button class="hide-visibility-btn add-date-btn" mat-icon-button>
                        <mat-icon class="material-icons-outlined"></mat-icon>
                    </button>
                    <!-- <button
                        *ngIf="i == 0"
                        class="add-date-btn"
                        color="primary"
                        mat-icon-button
                        (click)="addDate()"
                        matTooltip="Add application period"
                        i18n-matTooltip
                    >
                        <mat-icon class="material-icons-outlined">add_circle</mat-icon>
                    </button>
                    <button
                        *ngIf="i != 0"
                        class="add-date-btn"
                        color="primary"
                        mat-icon-button
                        (click)="removeDate(i)"
                        matTooltip="Remove application period"
                        i18n-matTooltip
                    >
                        <mat-icon class="material-icons-outlined">do_not_disturb_on</mat-icon>
                    </button> -->
                </div>
            </ng-container>
        </div>
    </div>
    <div *ngIf="occasionDatesErrors as errors">
        <div *ngFor="let error of errors | keyvalue">
            <div class="error-message" *ngFor="let msg of error.value">{{ msg }}</div>
        </div>
    </div>
</div>
